import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Pagination as PaginationWrapper, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink } from "@/components/ui/pagination";
export default function Pagination() {
  return <section id="pagination" className="w-full py-8 bg-background">
      <div className="container mx-auto px-4">
        <PaginationWrapper>
          <PaginationContent>
            {}
            <PaginationItem>
              <PaginationLink href="#" size="default" className="gap-1 px-2.5 sm:pl-2.5" aria-label="Ke halaman sebelumnya">
                <ChevronLeft className="size-4" />
                <span className="hidden sm:block">Sebelumnya</span>
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem>
              <PaginationLink href="#" isActive className="bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground border-primary">
                1
              </PaginationLink>
            </PaginationItem>
            
            <PaginationItem>
              <PaginationLink href="#">2</PaginationLink>
            </PaginationItem>
            
            <PaginationItem className="hidden sm:inline-flex">
              <PaginationLink href="#">3</PaginationLink>
            </PaginationItem>
            
            <PaginationItem className="hidden md:inline-flex">
              <PaginationLink href="#">4</PaginationLink>
            </PaginationItem>
            
            <PaginationItem className="hidden md:inline-flex">
              <PaginationLink href="#">5</PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>

            {}
            <PaginationItem>
              <PaginationLink href="#">10</PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem>
              <PaginationLink href="#" size="default" className="gap-1 px-2.5 sm:pr-2.5" aria-label="Ke halaman selanjutnya">
                <span className="hidden sm:block">Selanjutnya</span>
                <ChevronRight className="size-4" />
              </PaginationLink>
            </PaginationItem>
          </PaginationContent>
        </PaginationWrapper>
      </div>
    </section>;
}